module.exports = __webpack_public_path__ + "img/venue_hands_on_kitchen.a6d9a0bb.jpg";